
import  axios  from 'axios';
import Auth from "../../../Auth/Auth";
import auth0 from 'auth0-js';
import { AUTH_CONFIG } from '../../../Auth/auth0-variables';
import {Store} from "@material-ui/icons";
import history from "../../../history";
import {saveAPoliceDataInStore} from "../police/actions";


//export const LOAD_LOGIN_DATA = 'login/LOAD_LOGIN_DATA';
//export const SAVE_LOGIN_DATA = 'login/SAVE_LOGIN_DATA';
export const UPDATE_LOGIN_DATA = 'login/UPDATE_LOGIN_DATA';
export const IS_AUTHENTICATED = 'login/IS_AUTHENTICATED';
export const UPDATE_USER_PROFILE = 'login/UPDATE_USER_PROFILE';
export const UPDATE_AUTH = 'login/UPDATE_AUTH';

export const CLIENT_TYPE_CHANGE =  'login/CLIENT_TYPE_CHANGE';



//const auth = new Auth();

const authMine = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    responseType: 'token id_token',
    scope: 'openid profile'
});



export function updateUserProfileInStore(argUserProfiledData) {
    return {
        type: UPDATE_USER_PROFILE,
        userProfile:argUserProfiledData
    }
}




/*export function loadLoginDataInStore(argLoginData) {
    return {
        type: LOAD_LOGIN_DATA,
        loginData:argLoginData
    }
}


export function saveLoginDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_LOGIN_DATA,
        saveLoginResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}*/

export function updateLoginDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_LOGIN_DATA,
        updateLoginResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function isAuthenticatedInStore(argExpiresAt ) {
    return {
        type: IS_AUTHENTICATED,
        expiresAt:argExpiresAt
    }
}


export function clientTypeChangeInStore(argType ) {
    return {
        type: CLIENT_TYPE_CHANGE,
        clientType: argType
    }
}

/*Variables in Store
userProfile
accessToken
*/
/********************* End of InStore calls **************************/



//This may not be needed check on it later.
/*
export function getProfileAction(argUserProfile, argAccessToken) {
    return (dispatch, getState) => {
        console.log("Farshid the get profile is called");
        var self = this;
        try {
            if (!argUserProfile) {
                if (!argAccessToken) {
                    console.log('Access Token must exist to fetch profile');
                } else {
                    console.log("I have an access token. " + argAccessToken);
                }

                authMine.client.userInfo(argAccessToken, function (err, profile) {
                    if (profile) {
                        // self.userProfile = profile;
                        updateUserProfileInStore(profile);
                        var tempProfile = profile;
                        console.log("Hey Farshid the profile is " + profile);
                        //self.updateUserProfile();
                        console.log("Hey Farshid the profile nickname 1 :" + tempProfile.nickname);
                        console.log("Hey Farshid the profile sub  is 1:" + tempProfile.sub);

                    }
                });
            } else {
                console.log("Hey Farshid the profile is 2:" + argUserProfile.nickname);
                console.log("Hey Farshid the userid is 3:" + argUserProfile.sub);
                updateUserProfileInStore(argUserProfile);
            }
        } catch (Err) {
            console.log("The exception is " + Err.message);
            return Err;
        }
    }

}
*/


export function updateUserProfileAction(argUserProfile, argAccessToken) {
    console.log("Farshid the get profile is called");
    console.log(argAccessToken);
    return (dispatch, getState) => {
    var self=this;
    try {
        if (!argUserProfile) {
            if (!argAccessToken) {
                console.log('Access Token must exist to fetch profile');
            } else {
                console.log("I have an access token. " + argAccessToken);
            }

            authMine.client.userInfo(argAccessToken, function (err, profile) {
                if (profile) {
                    // self.userProfile = profile;

                    var tempProfile = profile;
                    //updateUserProfileInStore(tempProfile);
                    dispatch(updateUserProfileInStore(tempProfile), {});
                    console.log("Hey Farshid the profile is " + profile);
                    //self.updateUserProfile();
                    console.log("Hey Farshid the profile nickname 1 :" + tempProfile.nickname);
                    console.log("Hey Farshid the profile sub  is 1:" + tempProfile.sub);

                }
            });
        } else {
            console.log("Hey Farshid the profile is 2:" + argUserProfile.nickname);
            console.log("Hey Farshid the userid is 3:" + argUserProfile.sub);
            dispatch(updateUserProfileInStore(argUserProfile), {});
             //updateUserProfileInStore(argUserProfile);
        }
    }catch(Err){
        console.log("The exception is " + Err.message);
        return Err;
    }
        }

}

export function loginAction() {
    return (dispatch, getState) => {
        dispatch(authMine.authorize(),{});
        //this.userProfile= this.auth0.getProfile(this.accessToken);
        //this.getProfile();
    }
}

export function handleAuthenticationAction() {
    return (dispatch, getState) => {
        authMine.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                console.log(authResult);
                //trying this on Sat setSessionAction(authResult);
                dispatch(setSessionAction(authResult, {}));
                dispatch(updateUserProfileAction(null,authResult.accessToken));
                let expiresAt = (authResult.expiresIn * 1000) + new Date().getTime();
                dispatch(isAuthenticatedInStore(expiresAt));
                //getProfile();
            } else if (err) {
                //history.push('/home');
                //this.goHome();
                //console.log(err);
                //alert(`Error: ${err.error}. Check the console for further details.`);
            }
        });
    }
}


export function setSessionAction(authResult) {
    return (dispatch, getState) => {
        //let { updateLoginData } = this.props;
        // Set isLoggedIn flag in localStorage
        //localStorage.setItem('isLoggedIn', 'true');
        //updateLoginData("true");

        // Set the time that the access token will expire at
        let expiresAt = (authResult.expiresIn * 1000) + new Date().getTime();
        let accessToken = authResult.accessToken;
        let idToken = authResult.idToken;
        //let expiresAt = expiresAt;

        let tempLoginData = {};
        tempLoginData.accessToken = authResult.accessToken;
        tempLoginData.idToken = authResult.idToken;
        tempLoginData.expiresAt = expiresAt; //authResult.expiresAt;
        tempLoginData.isLoggedIn = true;
        //trying this on Sat updateLoginDataAction(tempLoginData);
        dispatch(updateLoginDataAction(tempLoginData, {}));
        // navigate to the home route
        //history.replace('/home');
        //this.goHome();
    }
}


export function renewSessionAction() {
    return (dispatch, getState) => {
        authMine.checkSession({}, (err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {

                // setSessionAction(authResult);
                dispatch(setSessionAction(authResult, {}));
                alert(`renewSession: Login was successful!`);
            } else if (err) {
                logoutAction();
                //setSessionAction(authResult
                console.log(err);
                alert(`renewSession: Could not get a new token (${err.error}: ${err.error_description}).`);
            }
        });
    }
}


export function logoutAction() {
    return (dispatch, getState) => {
        //let { saveLoginData } = this.props;
        // Remove tokens and expiry time
        let accessToken = null;
        let idToken = null;
        let expiresAt = 0;
        let tempLoginData = {'accessToken': ""};
        tempLoginData.accessToken = accessToken;
        tempLoginData.idToken = idToken;
        tempLoginData.expiresAt = expiresAt;
        tempLoginData.isLoggedIn = false;
        //dispatch(authMine.logout({returnTo:'http://localhost:3000/callback',clientID:AUTH_CONFIG.clientId }),{});
        //This was used when we were using the Auth0, but on 10-16-2023, I commented this out.
        //dispatch(authMine.logout({}),{});
        console.log("logout Action is called with Action");
        updateLoginDataAction(tempLoginData);

        // Remove isLoggedIn flag from localStorage
        //localStorage.removeItem('isLoggedIn');
        //saveLoginData("");
        //history.replace('/home');

        /*this.auth0.logout({
          return_to: window.location.origin
        });*/


        // navigate to the home route
        console.log("logoutAction is called with Action refreshing to home");
        history.replace('/home');
    }

}
/*
clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    
 */
export function updateLoginDataAction( argLoginData) {
    return (dispatch, getState) => {
       
        dispatch(updateLoginDataInStore(argLoginData, {}));

    }//end of return
}


export function saveAComment(argURL, argComment, argCaptchaToken) {
    return (dispatch, getState) => {
        const state = getState();
        saveACommentOnServer(argURL, argComment, argCaptchaToken).then(function(saveResponse){
            //dispatch(saveACommentInStore(saveResponse, {}));
            alert("Your comments were received. Thanks!");
        }, function(err){
            console.log(err);
            //alert("We got your comments- Thanks a lot!");
            alert("Due to some technical difficulties with our server, your comments were not received. Please try again later. Thanks!" );
            //console.log("I had an error saving a storage lot" + err.response.data);
           // dispatch(saveAPoliceDataInStore({}, err.response.data));
           
        });
    }//end of return
}


function saveACommentOnServer( argURL, argComment, argCaptchaToken ){
    var returnPromise = new Promise(function(resolve, reject){
        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveAComment(argURL, argComment, argCaptchaToken )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occurred on saving a comments " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });
    return returnPromise;
}



function getArrayOfPostsForSaveAComment(argURL, argComment, argCaptchaToken){
    let baseUrl = argURL+"platewiz/comments"+"?recaptchatoken="+argCaptchaToken;
    console.log(" on posting a Comments the URL is " + baseUrl );
    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argComment   ));
    }
    return arrayOfGets;
}







//****************************************
//  isAuthenticated
//****************************************
export function isAuthenticatedAction(argExpireAt) {
    return (dispatch, getState) => {
        //let authenticatedBool = auth.isAuthenticated();
        dispatch(isAuthenticatedInStore( argExpireAt, {}));

    }//end of return
}


export function clientTypeChange(argType) {
    return (dispatch, getState) => {
        //let authenticatedBool = auth.isAuthenticated();
        dispatch(clientTypeChangeInStore( argType, {}));
        
    }//end of return
}






